import { Group, Text, UnstyledButton } from '@mantine/core'
import {
  IconCheck,
  IconChevronRight,
  IconCircle,
  IconCircleCheckFilled,
  IconClock,
} from '@tabler/icons-react'
import { MaintenanceTask } from './utils'

interface TaskListItemProps {
  task: MaintenanceTask
  onClick: (task: MaintenanceTask) => void
  variant: 'user' | 'markku-scheduled' | 'markku-completed'
  backgroundColor?: string
  borderColor?: string
  hoverBackgroundColor?: string
  hoverBorderColor?: string
}

export function TaskListItem({
  task,
  onClick,
  variant,
  backgroundColor = 'var(--mantine-color-gray-0)',
  borderColor = 'var(--mantine-color-gray-2)',
  hoverBackgroundColor = 'var(--mantine-color-gray-1)',
  hoverBorderColor = 'var(--mantine-color-gray-3)',
}: TaskListItemProps) {
  const renderIcon = () => {
    if (variant === 'user') {
      return task.completed ? (
        <IconCheck
          size={20}
          color="var(--mantine-color-green-6)"
          style={{ flexShrink: 0 }}
        />
      ) : (
        <IconCircle
          size={20}
          color="var(--mantine-color-gray-4)"
          style={{ flexShrink: 0 }}
        />
      )
    }

    if (variant === 'markku-scheduled') {
      return (
        <IconClock
          size={20}
          color="var(--mantine-color-green-6)"
          style={{ flexShrink: 0 }}
        />
      )
    }

    return (
      <IconCircleCheckFilled
        size={20}
        color="var(--mantine-color-green-6)"
        style={{ flexShrink: 0 }}
      />
    )
  }

  const getTextColor = () => {
    if (variant === 'user' && task.completed) return 'gray.6'
    if (variant === 'markku-completed') return 'gray.6'
    return variant === 'markku-scheduled' ? 'gray.7' : 'inherit'
  }

  return (
    <UnstyledButton
      onClick={() => onClick(task)}
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 14px',
        borderRadius: 'var(--mantine-radius-md)',
        transition: 'all 0.2s',
        backgroundColor,
        border: `1px solid ${borderColor}`,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = hoverBackgroundColor
        e.currentTarget.style.borderColor = hoverBorderColor
        e.currentTarget.style.transform = 'translateX(2px)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = backgroundColor
        e.currentTarget.style.borderColor = borderColor
        e.currentTarget.style.transform = 'translateX(0)'
      }}
    >
      <Group gap="sm" wrap="nowrap" style={{ flex: 1 }}>
        {renderIcon()}
        <Text size="md" c={getTextColor()}>
          {task.title}
        </Text>
      </Group>
      <IconChevronRight
        size={18}
        color="var(--mantine-color-gray-4)"
        style={{ flexShrink: 0 }}
      />
    </UnstyledButton>
  )
}
